/**
 * banner.js - 管理端 Banner 接口封装
 * 对应后端: /manage/banner/**
 */
import request from '@/utils/request'

/** 分页列表 */
export function getBannerPage(params) {
  return request({
    url: '/manage/banner/page',
    method: 'post',
    params
  })
}

/** 详情 */
export function getBannerDetail(id) {
  return request({
    url: `/manage/banner/detail/${id}`,
    method: 'post'
  })
}

/** 新增 */
export function addBanner(data) {
  return request({
    url: '/manage/banner/add',
    method: 'post',
    data
  })
}

/** 修改 */
export function updateBanner(data) {
  return request({
    url: '/manage/banner/update',
    method: 'post',
    data
  })
}

/** 删除 */
export function deleteBanner(id) {
  return request({
    url: `/manage/banner/del/${id}`,
    method: 'post'
  })
}

/** 上架 */
export function publishBanner(id) {
  return request({
    url: `/manage/banner/publish/${id}`,
    method: 'post'
  })
}

/** 下架 */
export function offlineBanner(id) {
  return request({
    url: `/manage/banner/offline/${id}`,
    method: 'post'
  })
}
